import * as api from "Api";
import * as actions from "Actions";

export const fetchAvailableDashboard = () => {
  return (dispatch, getState) => {
    const { uen, id } = getState().auth.currentOrganization;
    const { paginationPage, pageSize, filterStatus } = getState().dashboardList;
    const {
      labels,
      legalForms,
      status,
      isPublic,
      operator,
      newDashboardIds
    } = getState().dashboardList.filter;
    const { backOffice } = getState().params;
    let data = {
      paginationPage,
      pageSize,
      status,
      labels,
      legalForms,
      uen,
      id,
      backOffice,
      isPublic,
      operator,
      filterStatus,
      newDashboardIds
    };
    dispatch(
      actions.fetchAvailableDashboard(
        api.getAvailableDashboard(data).then(res => {
          return res.data.data;
        })
      )
    );
  };
};

export const fetchDasboardJuridicalFormSuggestions = ({ searchWord, lng }) => {
  return (dispatch, getState) => {
    return dispatch(
      actions.setDashboardJuridicalFormSuggestions(
        api.getJuridicalForms({ searchWord, lng })
      )
    );
  };
};

export const deleteDashboard = id => (dispatch, getState) => {
  return dispatch(
    actions.deleteDashboard(
      api.deleteDashboardApi({
        id: id
      })
    )
  );
};
export const duplicateDashboard = id => (dispatch, getState) => {
  const {
    auth: { currentOrganization },
    params: { backOffice }
  } = getState();
  return dispatch(
    actions.duplicateDashboard(
      api.duplicateDashboard({
        uen: currentOrganization.uen,
        id: id,
        status: backOffice ? "STANDARD" : "CREATED",
        isBackOffice: backOffice ? true : false
      })
    )
  );
};
export const updatePrivacyDashboard = (id, isEditable) => (
  dispatch,
  getState
) => {
  return dispatch(
    actions.changePrivacyDashboard(
      api.updatePrivacyDashboard({
        id: id,
        isEditable: isEditable
      })
    )
  );
};

export const updateDashboardState = id => (dispatch, getState) => {
  const {
    auth: { currentOrganization }
  } = getState();
  return dispatch(
    actions.changeStateDashboard(
      api.updateStateDashboard({
        id: id,
        uen: currentOrganization.uen
      })
    )
  );
};

export const setDashboardPrivate = id => (dispatch, getState) => {
  return dispatch(
    actions.setDashboardPrivate(
      api.setDashboardPrivate({
        id: id
      })
    )
  );
};

export const useSharedDashboard = id => (dispatch, getState) => {
  const {
    auth: { currentOrganization }
  } = getState();
  return dispatch(
    actions.useSharedDashboard(
      api.useSharedDashboardApi({
        id: id,
        uen: currentOrganization.uen
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/dashboardList.js